<template>
    <div class="t-calendar-lessons"
        :class="{_day: this.type == 'day'}">

            <a :href="'/courses/' + lesson.id + '/' + lesson.slug + '/history'"
                    v-for="(lesson, index) in lessons_in_week"
                    :key="'lesson_' + index"
                    class="t-calendar-lesson t-calendar-lesson_select "
                    :style="'grid-column-start: ' + lesson.grid_column + '; grid-row-start:' + lesson.grid_row_start  + '; grid-row-end:' + lesson.grid_row_end"
                    @click.prevent="Open(lesson.id, lesson.slug)">
                <span class="t-calendar-lesson__title">{{ lesson.name }}</span>
            </a>


    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {mapActions} from 'vuex';
    import TimeMixin from '../TimeMixin';
    
    export default {
        mixins: [TimeMixin],
        computed: {
            ...mapGetters('calendar', ['day_week_header', 'date_active']),
            ...mapGetters('coursesList', ['streamsEntries']),

            lessons_in_week(){
                let les = [];

                for (let s = 0; s < this.streamsEntries.length; s++) {
                    let stream = this.streamsEntries[s];

                    for (let l = 0; l < stream.lessons.length; l++) {
                        let lesson = stream.lessons[l];

                        let date = new Date(lesson.date_time);

                        let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
                        let month = (parseInt(date.getMonth()) + 1)  < 10 ? '0' + (date.getMonth() + 1): (date.getMonth() + 1);
                        let date_string = date.getFullYear() + '.' + month + '.' + day;

                        if(this.week_arr.indexOf(date_string) >= 0){
                            let index = this.getIndex(date)  // берестя из миксина TimeMixin

                            let hours = date.getHours();
                            let minutes = date.getMinutes();

                            let grid_row_start = (hours + 1) * 2;
                            if(minutes === 0)
                                grid_row_start--;
                            let grid_row_end = grid_row_start + lesson.duration / 30;

                            les.push({
                                grid_column: index + 1,
                                grid_row_start: grid_row_start,
                                grid_row_end: grid_row_end,
                                name: stream.name,
                                id: stream.courseId,
                                slug: stream.slug
                            });
                        }
                    }
                }

                return les
            }
        },
        methods: {
            declOfNum(n, titles) {
                return titles[(n % 10 === 1 && n % 100 !== 11) ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2]
            },
            Open(id, slug){
                this.$router.push({name: 'courses_history', params: {id: id, slug: slug}});
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/vue_components/Calendar/MyEntries/Time.vue